import { render, staticRenderFns } from "./MspEventOrder.vue?vue&type=template&id=6f38a3d7&scoped=true&"
import script from "./MspEventOrder.vue?vue&type=script&lang=js&"
export * from "./MspEventOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38a3d7",
  null
  
)

export default component.exports